import React from "react";

/**
 * Master v5 Prompt 30C Phase 2 — the "smallest safe semantic editor"
 * for the `rich` input type (no rich-text-editor library exists in this
 * codebase — see the Phase 2 completion report). Content stays a PLAIN
 * STRING in `content.text`, exactly like `short`/`long` — richness is
 * two constrained, non-nested inline markers (`**bold**`, `_italic_`)
 * recognized by this exact regex on both the toolbar-insert side and the
 * render side. Never dangerouslySetInnerHTML, never raw HTML of any kind
 * — a value that happens to contain literal `<script>` text renders as
 * inert plain text, exactly like any other textarea value.
 */
const MARKUP_RE = /(\*\*[^*]+\*\*|_[^_]+_)/g;

export function renderRichText(text) {
  if (!text) return null;
  return text.split(MARKUP_RE).map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
    if (/^_[^_]+_$/.test(part)) return <em key={i}>{part.slice(1, -1)}</em>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

/** Wraps the current textarea selection in `marker` (or appends a
 * placeholder at the cursor if nothing is selected). Returns the new
 * full value + the new selection range so the caller can restore focus. */
export function wrapSelection(textareaEl, value, marker, placeholder) {
  const start = textareaEl?.selectionStart ?? value.length;
  const end = textareaEl?.selectionEnd ?? value.length;
  const selected = value.slice(start, end) || placeholder;
  const next = `${value.slice(0, start)}${marker}${selected}${marker}${value.slice(end)}`;
  const cursor = start + marker.length + selected.length + marker.length;
  return { next, cursor };
}
